export default __webpack_public_path__ + "static/media/christians-corner-clothes.71467324.png";